const PropTypes = require('prop-types');

class FooterLinkModel {
  constructor() {
    this.url = null;
    this.linkText = null;
    this.label = null;
    this.isAbsoluteUrl = false;
  }

  deserialise(data) {
    this.url = data.url || '';
    this.linkText = data.link_text;
    this.label = data.label;
    this.openInNewTab = data.open_in_new_tab === 'true';
    this.googleFollow = data.google_follow === 'true';

    return this;
  }
}

FooterLinkModel.propTypes = PropTypes.shape({
  url: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  label: PropTypes.string,
  openInNewTab: PropTypes.bool,
  googleFollow: PropTypes.bool,
});


module.exports = FooterLinkModel;



// WEBPACK FOOTER //
// ./src/common/models/prismic/components/FooterLinkModel.js